import React, { useState, useMemo } from "react"; 
import Modal from "react-bootstrap/Modal";
import QuanLyCongViecApi from "service/QuanLyCongViec/QuanLyCongViecApi";
import { pushNotification } from "../../../../utils/notifications";
import ReactDropdown from "react-dropdown"; 

const evaluationOptionsMap = {
    1: "Hoàn thành",
    2: "Không hoàn thành",
};

export const ModalDanhGia = ({ item, show, onHide, onSaved }) => {
    const [formData, setFormData] = useState({ Status: 1, Reason: "", Comment: "" });
    const [isSubmit, setIsSubmit] = useState(false);
    
    const evaluationOptions = useMemo(() =>
        Object.entries(evaluationOptionsMap).map(([value, label]) => ({
            value: parseInt(value, 10),
            label
        })), []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDropdownChange = (option) => {
        setFormData(prev => ({ ...prev, Status: option.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        const payload = {
            ...formData,
            Status: parseInt(formData.Status, 10)
        };

        try {
            const res = await QuanLyCongViecApi.evaluateTask(item.Id, payload);
            if (res.status === 200) {
                pushNotification("Đánh giá thành công!", "success", "TOP_CENTER", 2000);
                onSaved();
            } else {
                pushNotification(res.message || "Đánh giá thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error(error);
            pushNotification(error.message || "Đã xảy ra lỗi!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static" size="lg" className="modal-new modal fade text-left">
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right"><img src="/app-assets/images/icon-danh-gia-popup.png" alt="icon" /></span>
                    Đánh giá công việc
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmit}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>

            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="form form-horizontal">
                        <div className="form-body">
                            <div className="row">
                                <div className="form-group col-md-12">
                                    <label className="label-control color7-bold">Đánh giá</label>
                                    <ReactDropdown
                                        options={evaluationOptions}
                                        onChange={handleDropdownChange}
                                        value={evaluationOptions.find(opt => opt.value === formData.Status)}
                                        controlClassName="form-control input-sm"
                                    />
                                </div>
                                <div className="form-group col-md-12">
                                    <label className="label-control color7-bold">Lý do không hoàn thành</label>
                                    <textarea name="Reason" value={formData.Reason} onChange={handleInputChange} className="form-control input-sm" rows="3" style={{ resize: 'vertical' }}></textarea>
                                </div>
                                <div className="form-group col-md-12">
                                    <label className="label-control color7-bold">Nhận xét</label>
                                    <textarea name="Comment" value={formData.Comment} onChange={handleInputChange} className="form-control input-sm" rows="3" style={{ resize: 'vertical' }}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmit}>
                        <span><i className="mdi mdi-close"></i></span>&nbsp; Đóng
                    </button>
                    <button type="submit" className="btn btn-new-main button-popup-submit" disabled={isSubmit}>
                        <span><img src="/app-assets/images/icon-send-v2.png" alt="save" /></span>&nbsp; {isSubmit ? "Đang xử lý..." : "ĐÁNH GIÁ"}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};